module.exports = __webpack_public_path__ + "static/media/21.021ffb73.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/21.svg
// module id = 2813
// module chunks = 3